export default __webpack_public_path__ + "static/media/745.fe74e982.png";